import styled from '@emotion/styled';

export interface FormValues extends Omit<Remind.InsiteConfig, 'inSiteRemindEnable'> {}

export type FV = FormValues;

export const GroupContainer = styled.div`
  border: solid 1px #f0f2f5;
  > header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 48px;
    padding: 0 16px;
    border-bottom: solid 1px #f0f2f5;
    > h3 {
      position: relative;
      margin-bottom: 0;
      font-size: 14px;
      text-indent: 8px;
      &::before {
        display: inline-block;
        content: '';
        position: absolute;
        top: 5px;
        left: 0;
        width: 3px;
        height: 12px;
        background: var(--ant-primary-color);
      }
    }
  }
  > div {
    margin: 16px;
    > * {
      margin-bottom: 16px;
    }
    .ant-checkbox-wrapper {
      height: 30px;
      margin-right: 40px;
      margin-left: 0 !important;
    }
  }
`;

export const GatherContainer = styled.div`
  background: #f7f9fa;
  > h4 {
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 16px;
    margin-bottom: 0;
    font-size: 14px;
  }
  > div {
    padding: 12px 18px;
    border-top: solid 1px #f0f2f5;
    > h5 {
      font-size: 14px;
    }
  }
`;
